'use client'
import { alpha } from "@mui/material"
import { red } from "@mui/material/colors"

// Clé de définition de la préférence de la langue de l'utilisateur
const preferredThemeName = "mui-mode"

// Couleurs principales de l'application
export const primaryColors = {
  light: "#01a7f2", 
  main: "#0087cf", 
  dark: "#005699",
}

// Couleurs secondaires de l'application
export const secondaryColors = {
  light: "#184673", // "#567d9e",
  main: "#053661", // "#2b485f",
  dark: "#001d3d", // "#193347",
}

// Customosation de l'apparence du composant List de mui
const customListItem = {
  // color: "#ffffff",
  // color: "#ffd02b",
  // backgroundColor: "rgba(66, 133, 244, 0.16)",
}

// Customisation de l'apparence du label d'un input lorsqu'il est en surbrillance
// ou a un focus
export const labelShrink = {
  padding: 0,
  marginTop: 0,
  paddingLeft: 12,
  paddingRight: 12,
  borderRadius: 16,
  marginLeft: "-6px",
  // color: "#ffffff",
  // backgroundColor: "#053661",
}

export const getSurfaceVariants = (customColor) => {
  return [
    {
      props: { variant: 'beautiful' },
      style: {
        borderRadius: 24,
        backgroundColor: customColor,
        border: "1px solid rgba(4, 134, 61, 0.22)",
      },
    },
    {
      props: { variant: 'glass' },
      style: {
        color: customColor,
        borderRadius: "50px",
        backgroundColor: "rgba(4, 134, 61, 0.05)",
        border: "1px solid rgba(4, 134, 61, 0.05)",
      },
    },
    {
      props: { variant: 'black-glass' },
      style: {
        backdropFilter: "blur(4px)",
        color: `#ffffff !important`,
        backgroundColor: `#000000 !important`,
        border: `1px solid ${alpha("#ffffff", .095)}`,
      },
    },
    {
      props: { variant: 'white-glass' },
      style: {
        backdropFilter: "blur(4px)",
        color: `#000000 !important`,
        backgroundColor: `#ffffff !important`,
        border: `1px solid ${alpha("#000000", .095)}`,
      },
    },
  ]
}

const getCustomTransitions = () => {
  return {
    duration: {
      shortest: 50,
      shorter: 75,
      short: 100,
      standard: 125,
      complex: 175,
      enteringScreen: 100,
      leavingScreen: 150,
    },
  }
}

// Customisation des composants mui
const components = (customColor: string) => ({
  MuiList: {
    styleOverrides: {
      root: {
        "&.MuiList-root": {
          background: alpha(customColor, .35),
          backdropFilter: "blur(10px) saturate(181%)",
        },
      },
    },
  },
  MuiListItem: {
    styleOverrides: {
      root: {
        "&:hover": customListItem,
        "&.Mui-selected": customListItem,
        "&.Mui-selected:hover": customListItem
      },
    },
  },
  MuiAlert: {
    styleOverrides: {
      root: {
        paddingTop: 2,
        paddingBottom: 2,
        borderRadius: "24px",
        backdropFilter: "blur(8px) saturate(181%)",
        "& .MuiAlert-icon": {
          width: 28,
          height: 28,
          display: "flex",
          alignSelf: "center",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          borderRadius: "50%",
          padding: "0px 8px",
        },
      },
      standardInfo: {
        backgroundColor: "rgba(2, 136, 209, 0.35)",
        color: "#ffffff",
        "& .MuiAlert-icon": {
          // color: "#0288d1",
          color: "#ffffff",
          backgroundColor: "#0288d1",
        },
      },
      standardSuccess: {
        backgroundColor: "rgba(56, 142, 60, 0.35)",
        color: "#ffffff",
        "& .MuiAlert-icon": {
          // color: "#388e3c",
          color: "#ffffff",
          borderRadius: "50%",
          backgroundColor: "#388e3c",
        }
      },
      standardWarning: {
        backgroundColor: "rgba(251, 140, 0, 0.35)",
        color: "#ffffff",
        "& .MuiAlert-icon": {
          // color: "#fb8c00",
          color: "#ffffff",
          backgroundColor: "#fb8c00",
        }
      },
      standardError: {
        backgroundColor: "rgba(211, 47, 47, 0.35)",
        color: "#ffffff",
        "& .MuiAlert-icon": {
          // color: "#d32f2f",
          color: "#ffffff",
          backgroundColor: "#d32f2f",
        }
      }
    },
  },
  MuiDialog: {
    styleOverrides: {
      root: {
        "& .MuiPaper-root": {
          borderRadius: "32px",
          // background: "rgba(17, 25, 40, .35)",
          backdropFilter: "blur(10px) saturate(181%)",
        },
        "& .MuiDialogTitle-root": {
          paddingLeft: 8,
          paddingRight: 8
        },
        "& .MuiDialogContent-root": {
          paddingLeft: 8,
          paddingRight: 8
        },
      },
    },
  },
  MuiDrawer: {
    styleOverrides: {
      root: {
        "& .MuiList-root": {
          paddingBottom: 5*8,
          width: 'auto'
        },
        "& .MuiButtonBase-root .MuiSvgIcon-root": {
          color: "#fff",
        },
        "& .MuiBox-root::-webkit-scrollbar": {
          display: "none",
          scrollbarWidth: "none",
          "-ms-overflow-style": "none",
        },
        "&.MuiDrawer-root.MuiDrawer-anchorLeft.MuiDrawer-modal.MuiModal-root > \
        .MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorLeft": {
          backdropFilter: "blur(10px) saturate(181%)",
          "&  .MuiListSubheader-root": {
            backdropFilter: 'blur(4px)',
          },
        },
        "&.MuiDrawer-root.MuiDrawer-anchorLeft.MuiDrawer-modal.MuiModal-root > \
        .MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorLeft \
        .MuiListItem-root .MuiButtonBase-root": {
          height: 32,
        },
        "&.MuiDrawer-root.MuiDrawer-anchorLeft.MuiDrawer-modal.MuiModal-root > \
        .MuiPaper-root.MuiPaper-elevation.MuiPaper-elevation16.MuiDrawer-paper.MuiDrawer-paperAnchorLeft \
        .MuiListItem-root .MuiTypography-root": {
          fontSize: "0.9rem",
          overflow: "hidden",
          whiteSpace: "no-wrap",
          textOverflow: "ellipsis"
        },
      },
    },
  },
  MuiPaper: {
    styleOverrides: {
      root: {
        "&.MuiPaper-root": {
          borderRadius: "16px",
          backgroundImage: 'unset',
          border: 0,
        },
      }
    },
  },
  MuiMenu: {
    styleOverrides: {
      root: {
        "&.MuiPaper-root": {
          borderRadius: "16px",
          backgroundImage: 'unset',
          border: 0,
        },
      }
    },
  },
  MuiAccordion: {
    styleOverrides: {
      root: {
        "&.MuiAccordion-root": { borderRadius: 24 },
      }
    },
  },
  MuiButton: {
    variants: [ ...getSurfaceVariants(customColor) ],
    styleOverrides: {
      root: {
        paddingLeft: 12,
        paddingRight: 12,
        textTransform: "capitalize",
        borderRadius: "50px !important",
        border: "1px solid rgba(133, 119, 126, 0.1) !important",
      }
    },
  },
  MuiIconButton: {
    variants: [ ...getSurfaceVariants(customColor) ],
  },
  MuiFormControl: {
    styleOverrides: {
      root: {
        borderRadius: "50px !important",
        "& .MuiInputBase-root": {
          borderRadius: "50px !important",
        },
        "& .MuiInputBase-root:before": {
          borderBottom: '0px !important',
        },
        "& .MuiInputBase-root:after": {
          borderBottom: '0px !important',
        },
        "& .MuiInputLabel-root.MuiInputLabel-shrink": {
          ...labelShrink,
        },
        "& .MuiInputLabel-root.MuiInputLabel-sizeSmall.MuiInputLabel-shrink": {
          ...labelShrink,
        },
      }
    }
  },
  MuiChip: {
    styleOverrides: { root: { color: "#ffffff" } },
    variants: [ ...getSurfaceVariants(customColor) ],
  },
  MuiDivider: {
    styleOverrides: {
      root: {
        "&.MuiDivider-root::before": {
          // borderColor: "#ffffff",
        },
        "&.MuiDivider-root::after": {
          // borderColor: "#ffffff",
        },
      }
    },
  },
  MuiAutocomplete: {
    styleOverrides: {
      root: {
        "& .MuiAutocomplete-popper": {
          
        },
      }
    },
  },
})

/**
 * Cet objet global permet la gestion des theme de l'application
 * @name APP_THEME
 */
export const APP_THEME = {
  PREFERRED_THEME: preferredThemeName,
  TYPE: { LIGHT: "light", DARK: "dark" },
  LIGHT: {
    cssVariables: {
      colorSchemeSelector: '.theme-%s',
    },
    colorSchemes: { light: true, dark: true },
    palette: {
      mode: "light",
      direction: "ltr",
      contrastThreshold: 3,
      primary: { ...primaryColors, contrastText: "#fff" },
      // background: { default: "#ffffff", paper: "#f6f9ff" },
      background: {
        paper: "rgba(225, 225, 225, .35)",
        default: "rgba(225, 225, 225, 1)"
      },
      secondary: { ...secondaryColors, contrastText: "#ffffff" },
      error: {
        light: red[500],
        main: red[500],
        dark: red[700],
        contrastText: "#ffffff",
      },
    },
    components: {
      ...components('rgba(0, 0, 0, 1)'),
    },
    transitions: {
      ...getCustomTransitions(),
    },
  },
  DARK: {
    cssVariables: {
      colorSchemeSelector: '.theme-%s',
    },
    colorSchemes: {
      light: true,
      dark: true,
    },
    palette: {
      mode: "dark",
      direction: "ltr",
      contrastThreshold: 3,
      secondary: { ...secondaryColors, contrastText: "#ffffff" },
      background: {
        paper: "rgba(25, 25, 25, .35)",
        default: "rgba(0, 0, 0, 1)"
      },
      primary: {
        ...primaryColors,
        contrastText: "#ffffff",
        hint: "rgba(255, 255, 255, 0.5)",
      },
      error: {
        light: red[500],
        main: red[500],
        dark: red[700],
        contrastText: "#ffffff",
      },
    },
    components: {
      ...components('rgba(255, 255, 255, 1)'),
    },
    transitions: {
      ...getCustomTransitions(),
    },
  }
}

/**
 * Cette fonction permet de récupérer la langue de l'utilisateur stockée dans le local storage
 * @name getLang
 */
export const getLang = () => localStorage.getItem("lang")

